<template>
  <div class="cookie-settings-modal">
    <div :class="['wrapper', { visible: isWrapperVisible }]" :style="{ width: `${width}px` }">
      <div class="header">
        <span class="title">{{ $t('cookieSettingsModal.header.title') }}</span>
        <span class="description">{{ $t('cookieSettingsModal.header.description') }}</span>
      </div>
      <div class="content">
        <accordion v-for="(item, index) in accordions" :key="index">
          <div class="header-left-col" slot="header-left-col">
            <span class="title">{{ $t(item.title) }}</span>
            <span class="icon"><img src="https://blockben-blog-prd.s3.eu-central-1.amazonaws.com/images/icons/arrowDown.svg" /></span>
          </div>
          <div class="header-right-col" slot="header-right-col">
            <base-switch
              :defaultSelected="item.switchState"
              @valueChanged="handleSwitchChange(index, ...arguments)"
            />
          </div>
          <div class="accordion-content" slot="body" v-html="$t(item.description)" />
        </accordion>
        <div class="used-cookies">
          <span class="title">{{ $t('cookieSettingsModal.usedCookies.title') }}</span>
          <ul class="used-cookies-list">
            <li v-for="(item, index) in usedCookies" :key="index">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="footer">
        <a
          href="https://data.blockben.com/gdpr/Privacy_Policy_en.pdf"
          target="_blank"
          class="footer-link"
          >{{ $t('cookieSettingsModal.privacyPolicy.text') }}</a
        >
        <base-button
          :title="$t('cookieSettingsModal.submitBtn.text')"
          @buttonClicked="handleSubmitBtnClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'

import Accordion from './Accordion.vue';
import BaseButton from './BaseButton.vue';
import BaseSwitch from './BaseSwitch.vue';

Vue.use(VueCookies)

export default {
  name: 'CookieSettingsModal',
  props: {
    width: {
      tpye: Number,
      required: false,
      default: 800,
    },
  },
  components: {
    Accordion,
    BaseButton,
    BaseSwitch,
  },
  data() {
    return {
      isWrapperVisible: false,
      accordions: [
        {
          title: 'cookieSettingsModal.functionalCookies.title',
          description: 'cookieSettingsModal.functionalCookies.description',
          switchState: true,
        },
        {
          title: 'cookieSettingsModal.thirdPartyCookies.title',
          description: 'cookieSettingsModal.thirdPartyCookies.description',
          switchState: true,
        },
      ],
      usedCookies: ['Google Tag Manager'],
    };
  },
  methods: {
    handleSubmitBtnClick() {
      if (this.accordions[0].switchState && this.accordions[1].switchState) {
        this.$cookies.set('cookie_status', 'all', 60 * 60 * 24 * 30);
      } else if (this.accordions[0].switchState) {
        this.$cookies.set('cookie_status', 'functional', 60 * 60 * 24 * 30);
      } else if (this.accordions[1].switchState) {
        this.$cookies.set('cookie_status', 'third_party', 60 * 60 * 24 * 30);
      } else {
        this.$cookies.set('cookie_status', 'none', 60 * 60 * 24 * 30);
      }
      this.$emit('settingsSubmitted');
    },
    handleSwitchChange(index, payload) {
      this.accordions[index].switchState = payload;
    },
  },
  created() {
    switch (this.$cookies.get('cookie_status')) {
      case 'all':
        this.accordions[0].switchState = true;
        this.accordions[1].switchState = true;
        break;
      case 'functional':
        this.accordions[0].switchState = true;
        this.accordions[1].switchState = false;
        break;
      case 'third_party':
        this.accordions[0].switchState = false;
        this.accordions[1].switchState = true;
        break;
      case 'none':
        this.accordions[0].switchState = false;
        this.accordions[1].switchState = false;
        break;
      default:
        this.accordions[0].switchState = true;
        this.accordions[1].switchState = true;
        break;
    }

    this.$nextTick(() => {
      this.isWrapperVisible = true;
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
.cookie-settings-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(39, 38, 48, 0.95);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
}

.wrapper {
  background: #fff;
  height: auto;
  border-radius: 25px;
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  @media screen and (max-width: 991px) {
    width: calc(100% - 50px) !important;
  }

  &.visible {
    max-height: calc(100vh - 50px);
    overflow: scroll;
  }
}

.header {
  padding: 36px 44px 33px 40px;

  @media screen and (max-width: 575px) {
    padding: 30px;
  }

  .title {
    display: block;
    font-size: 30px;
    line-height: 36px;
    margin: 0 0 16px;
  }

  .description {
    font-size: 14px;
    line-height: 24px;

    @media screen and (max-width: 575px) {
      line-height: 20px;
    }
  }
}

.content {
  .accordion {
    /deep/ {
      & > .wrapper {
        @media screen and (max-width: 575px) {
          padding: 30px;
        }
      }

      .accordion-body {
        @media screen and (max-width: 575px) {
          max-width: 100%;
          padding: 20px 0 0;
        }
      }
    }

    .title {
      font-size: 24px;
      line-height: 38px;
      display: inline-block;

      @media screen and (max-width: 575px) {
        font-size: 14px;
        line-height: 18px;
      }
    }

    .icon {
      margin: 0 0 0 auto;
      display: inline-block;
      transition: all 0.3s ease-in-out;
    }
  }

  /deep/ .accordion-header {
    &.opened {
      .icon {
        transform: rotate(-180deg);
      }
    }
  }
}

.header-left-col {
  display: flex;
  align-items: center;

  @media screen and (max-width: 575px) {
    margin: 0 10px 0 0;
  }

  /deep/ .header-left-col-wrapper {
    @media screen and (max-width: 575px) {
      max-width: 50%;
      margin: 0 10px 0 0;
    }
  }
}

.header-right-col {
  /deep/ .base-switch {
    @media screen and (max-width: 575px) {
      min-width: 90px;
    }
  }
}

.accordion-content {
  font-size: 14px;
  line-height: 24px;
}

.used-cookies {
  border-top: 1px solid rgba(#262a30, 0.06);
  width: 100%;
  padding: 23px 42px 18px 40px;

  @media screen and (max-width: 575px) {
    padding: 30px;
  }

  .title {
    font-size: 24px;
    line-height: 38px;
    display: inline-block;

    @media screen and (max-width: 575px) {
      font-size: 14px;
      line-height: 18px;
    }
  }
}

.used-cookies-list {
  padding: 12px 0 0 12px;
  margin: 0;
  list-style-type: none;
  font-size: 14px;
  line-height: 24px;
}

.footer {
  border-top: 1px solid rgba(#262a30, 0.06);
  display: flex;
  align-items: center;
  padding: 23px 20px 35px 40px;

  @media screen and (max-width: 575px) {
    flex-wrap: wrap;
    padding: 30px;
    justify-content: center;
  }

  .base-button {
    margin: 0 0 0 auto;

    @media screen and (max-width: 575px) {
      display: block;
      width: 100%;
      margin: 30px 0 0;
    }

    /deep/ button {
      padding-left: 50px;
      padding-right: 50px;

      @media screen and (max-width: 575px) {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
